import useSWR from 'swr';
import { fetchEndpointData } from '@/utils/fetch.client';

export interface BetaJoinRequest {
  id: string;
  email: string;
  name: string;
  job_title: string | null;
  company: string | null;
  heard_from: string | null;
  status: 'pending' | 'approved' | 'denied';
  created_at: string;
  reviewed_at: string | null;
  reviewed_by_user_id: string | null;
  denial_reason: string | null;
}

interface ListRequestsResponse {
  requests: BetaJoinRequest[];
  total: number;
}

export type JoinRequestStatusFilter = 'all' | 'pending' | 'approved' | 'denied';

export interface AdminBetaRequestsQuery {
  status: JoinRequestStatusFilter;
  page: number;
  pageSize: number;
}

function buildKey({ status, page, pageSize }: AdminBetaRequestsQuery) {
  const params = new URLSearchParams();
  if (status !== 'all') params.set('status', status);
  params.set('limit', String(pageSize));
  params.set('offset', String((page - 1) * pageSize));
  return `/api/v1/admin/beta-requests?${params.toString()}`;
}

export function useAdminBetaRequests(query: AdminBetaRequestsQuery) {
  const key = buildKey(query);
  const { data, mutate, isLoading, error } = useSWR(key, () => fetchEndpointData<ListRequestsResponse>(key), {
    keepPreviousData: true,
  });
  return {
    requests: data?.requests ?? [],
    total: data?.total ?? 0,
    mutate,
    isLoading,
    error,
  };
}

export async function approveBetaRequest(id: string) {
  return fetchEndpointData<BetaJoinRequest>(`/api/v1/admin/beta-requests/${encodeURIComponent(id)}/approve`, {
    method: 'POST',
  });
}

export async function denyBetaRequest(id: string, reason?: string) {
  return fetchEndpointData<BetaJoinRequest>(`/api/v1/admin/beta-requests/${encodeURIComponent(id)}/deny`, {
    method: 'POST',
    body: { reason: reason?.trim() || undefined },
  });
}
